jQuery(function($) {

    // var windowWidth = $(window).width();
    // var windowSm = 768;
    // if ( windowSm <= windowWidth) {
    //     //少し下にスクロールしたらTopへ戻るボタンを表示するためのもの
    // } 
    $(window).on('scroll', function () {
        var position = $(this).scrollTop();
        var windowWidth = $(window).width();
        var windowSm = 767;
        if (windowWidth <= windowSm) {
            if ( 200 < position ) {
                $('.c_fixSidebar').fadeIn();
            } else {
                $('.c_fixSidebar').fadeOut();
            }
        } else {
            if ( 200 < position ) {
                $('.c_fixSidebar').fadeIn();
            } else {
                $('.c_fixSidebar').fadeOut();
            }
        }
    });

});